import { render } from "./CookiePolicy.vue?vue&type=template&id=ca159a5a"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__